export const defaultFilterPayload = () => ({
  categories: [],
  assignees: [],
  teams: [],
});

export const defaultFilters = () => ({
  status: '',
  created_by: 'all',
  waiting_on: '',
  q: '',
  sla_status: '',
  due_soon: false,
  assignee_id: '',
});

export const defaultTicketForm = () => ({
  subject: '',
  description: '',
  visibility: 'private',
  ticket_type: 'support',
  priority: 'normal',
  category: '',
  attachments: [],
});

export const defaultReplyForm = () => ({
  body: '',
  product_status: '',
  internal: false,
  attachments: [],
});

export const defaultAssistanceForm = () => ({
  real_estate_context: 'maintenance',
  category: 'hidraulica',
  severity: 'normal',
  title: '',
  description: '',
  responsibility: 'indefinido',
  cost_bearer: 'indefinido',
  supplier_name: '',
  supplier_document: '',
  budget_amount: '',
  currency: 'BRL',
  evidence_kind: 'photo',
  evidence_label: '',
  evidence_url: '',
  evidence_checksum: '',
  evidence_description: '',
});

export const defaultAssistanceReopenForm = () => ({
  reason: '',
  evidence_kind: 'photo',
  evidence_label: '',
  evidence_url: '',
});

export const defaultAssistanceCostForm = () => ({
  amount: '',
  bearer: 'indefinido',
  notes: '',
  evidence_kind: 'invoice',
  evidence_label: '',
  evidence_url: '',
});

export const defaultAssistanceEvidenceForm = () => ({
  body: '',
  evidence_kind: 'photo',
  evidence_label: '',
  evidence_url: '',
  evidence_checksum: '',
  evidence_description: '',
});

export const defaultAssistanceOutcomeForm = () => ({
  resolution_outcome: 'resolved',
  satisfaction_score: '5',
  satisfaction_comment: '',
  recurrence: false,
  recurrence_reason: '',
  follow_up_required: false,
  cost_disputed: false,
  close_ticket: false,
});

export const defaultTeamHandoverForm = () => ({
  assigned_team_id: '',
  reason: '',
});

export const compactObject = payload =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === '') return acc;
    acc[key] = value;
    return acc;
  }, {});

export const evidenceFromFields = form => {
  const evidence = compactObject({
    kind: form.evidence_kind,
    label: form.evidence_label,
    url: form.evidence_url,
    checksum: form.evidence_checksum,
    description: form.evidence_description,
  });

  return Object.keys(evidence).some(key => key !== 'kind') ? [evidence] : [];
};

export const buildAssistancePayload = form => {
  const evidence = evidenceFromFields(form);
  return compactObject({
    real_estate_context: form.real_estate_context,
    category: form.category,
    severity: form.severity,
    title: form.title,
    description: form.description,
    responsibility: form.responsibility,
    cost_bearer: form.cost_bearer,
    supplier_name: form.supplier_name,
    supplier_document: form.supplier_document,
    budget_amount: form.budget_amount,
    currency: form.currency,
    evidence: evidence.length ? evidence : undefined,
  });
};

export const buildReopenPayload = form => {
  const evidence = evidenceFromFields(form);
  return compactObject({
    reason: form.reason,
    evidence: evidence.length ? evidence : undefined,
  });
};

export const buildCostPayload = form => {
  const evidence = evidenceFromFields(form);
  return compactObject({
    amount: form.amount,
    bearer: form.bearer,
    notes: form.notes,
    evidence: evidence.length ? evidence : undefined,
  });
};

export const buildEvidencePayload = form => {
  const evidence = evidenceFromFields(form);
  return compactObject({
    body: form.body,
    evidence: evidence.length ? evidence : undefined,
  });
};

export const buildOutcomePayload = form =>
  compactObject({
    resolution_outcome: form.resolution_outcome,
    satisfaction_score: form.satisfaction_score,
    satisfaction_comment: form.satisfaction_comment,
    recurrence: form.recurrence,
    recurrence_reason: form.recurrence_reason,
    follow_up_required: form.follow_up_required,
    cost_disputed: form.cost_disputed,
    close_ticket: form.close_ticket,
  });
